
export const makePositiveOrUnchanged = (number: number): number => {
    //   if (number < 0) {
    return Math.abs(number)
    // } else {
    //     return number
    // }
}
